export default __webpack_public_path__ + "static/media/Appreciation Session.8ecd89f4.JPG";